"use client";

import { useEffect } from "react";

/** 根错误边界：`/chat` 之外的路由崩了由它兜住并上报。
 *  必须自带 <html>/<body>——它替换的是整棵树。 */
export default function GlobalError({
  error,
  reset
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    void fetch("/api/client-error", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        kind: "global-error",
        message: error.message,
        digest: error.digest,
        stack: error.stack,
        url: window.location.href,
        ua: navigator.userAgent
      })
    }).catch(() => {});
  }, [error]);

  return (
    <html lang="zh-CN">
      <body style={{ fontFamily: "system-ui, sans-serif", padding: "3rem", lineHeight: 1.7 }}>
        <h2 style={{ fontSize: "1.1rem", margin: 0 }}>页面出错了</h2>
        <p style={{ color: "#666", fontSize: "0.9rem" }}>已自动上报，可以重试。</p>
        <button
          onClick={reset}
          style={{
            marginTop: "1rem",
            padding: "0.5rem 1rem",
            borderRadius: 8,
            border: "1px solid #ccc",
            background: "transparent",
            cursor: "pointer"
          }}
        >
          重试
        </button>
      </body>
    </html>
  );
}
